// EN
export const hotelRatesManager = {
  perNight: "/ noite",
  roomFallback: "Quarto #{id}",

  header: {
    eyebrow: "Tarifas principais",
    title: "Tarifas do hotel",
    subtitle:
      "Crie tarifas base e aplique-as a um ou mais quartos. As tarifas derivadas sincronizam com o gerenciador de canais.",
    newMain: "Nova tarifa principal",
  },
  states: {
    loading: "Carregando tarifas…",
    emptyTitle: "Ainda não há tarifas",
    emptySubtitle:
      "Crie a primeira tarifa principal para começar a gerenciar preços e sincronizar com o gerenciador de canais.",
    createFirst: "Criar primeira tarifa",
  },
  card: {
    mainBadge: "Principal",
    occupancy: "Ocup. {count}",
    minStay: "Mín. {count} noite | Mín. {count} noites",
    editRate: "Editar tarifa",
    deleteRate: "Excluir tarifa",
    rooms: "Quartos",
    syncedTooltip: "Sincronizado com o gerenciador de canais",
    removeSyncedTooltip: "Remover (atenção: gerenciador de canais)",
    removeRoomTooltip: "Remover deste quarto",
    add: "Adicionar",
    selectRoom: "Selecionar quarto",
    derivedBadge: "Derivada",
    derivedFrom: "de {name}",
    sameNameHint: "Há outra «{name}» com outro preço ou condições. Cada cartão é editado separadamente.",
    editDerived: "Editar derivada",
    deleteDerived: "Excluir derivada",
  },
  derived: {
    toggle: "Tarifas derivadas",
    empty:
      "Ainda não há tarifas derivadas. Crie uma para Booking.com, Airbnb ou OTAs específicas.",
    newDerived: "Nova tarifa derivada",
  },
  common: {
    allRooms: "todos os quartos",
    cancel: "Cancelar",
    saving: "Salvando…",
    creating: "Criando…",
    saveChanges: "Salvar alterações",
    removeAll: "Limpar tudo",
  },
  mainModal: {
    editTitle: "Editar tarifa principal",
    newTitle: "Nova tarifa principal",
    nameLabel: "Nome",
    namePlaceholder: "Ex.: Tarifa padrão, Fim de semana…",
    priceLabel: "Preço por noite",
    occupancyLabel: "Ocupação",
    minStayLabel: "Estadia mínima (noites)",
    maxStayLabel: "Estadia máxima (noites)",
    validityLabel: "Validade",
    permanent: "Permanente",
    dateRange: "Intervalo de datas",
    from: "De",
    to: "Até",
    descriptionLabel: "Descrição (opcional)",
    descriptionPlaceholder: "Notas internas sobre esta tarifa…",
    searchPlaceholder: "Buscar quarto…",
    selectAllShort: "Todos",
    noResults: 'Nenhum resultado para "{query}"',
    noRoomsAvailable: "Nenhum quarto disponível",
    editInfo: "As alterações serão aplicadas a {rooms} deste cartão.",
    createRate: "Criar tarifa",
  },
  derivedModal: {
    editTitle: "Editar tarifa derivada",
    newTitle: "Nova tarifa derivada",
    subtitle: "Derivada de {name} · {price}",
    nameLabel: "Nome da tarifa derivada",
    namePlaceholder: "Ex.: Booking.com, Airbnb, Sem café da manhã…",
    nameHint: "Este nome identifica a tarifa no gerenciador de canais.",
    adjustTypeLabel: "Tipo de ajuste",
    percentage: "Porcentagem",
    fixedAmount: "Valor fixo",
    adjustValueLabel: "Valor do ajuste",
    adjustValueHint: "(negativo = desconto)",
    resultPriceLabel: "Preço resultante",
    baseLabel: "Base",
    applyToRooms: "Aplicar aos quartos",
    onlyMainRooms: "Só são exibidos os quartos que têm a tarifa principal.",
    noRoomsWithMain: "A tarifa principal ainda não está aplicada a nenhum quarto.",
    selectAll: "Selecionar todos",
    editInfo:
      "Editar atualizará o ajuste em {rooms} que têm esta tarifa derivada.",
    createDerived: "Criar derivada",
  },
  removeModal: {
    title: "Remover do quarto",
    syncWarnTitle: "Esta tarifa está sincronizada com o gerenciador de canais",
    syncWarnBody:
      "Removê-la pode {break} das tarifas no Channex para este quarto. Verifique o gerenciador de canais antes de continuar.",
    syncWarnBreak: "quebrar a sincronização",
    confirmText: "Esta ação removerá a tarifa {rate} do quarto {room}.",
    roomLabel: "Quarto",
    rateLabel: "Tarifa",
    statusLabel: "Status",
    syncedWithChannex: "Sincronizado com o Channex",
    removing: "Removendo…",
    removeAnyway: "Entendo, remover mesmo assim",
    confirm: "Remover do quarto",
  },
  deleteModal: {
    title: "Excluir tarifa",
    warnTitle: "Esta ação não pode ser desfeita",
    warnBody: "A tarifa {rate} será removida de {rooms}.",
    roomsCount: "{count} quarto | {count} quartos",
    syncedWarn:
      "Alguns quartos estão sincronizados com o Channex. Isso pode afetar a sincronização das tarifas.",
    confirmLabel: "Digite {name} para confirmar",
    deleting: "Excluindo…",
    confirm: "Excluir permanentemente",
  },
  toasts: {
    loadError: "Erro ao carregar as tarifas do hotel",
    mainCreated: "Tarifa criada em {count} quarto | Tarifa criada em {count} quartos",
    createdPartial: "{ok} criadas, {fail} com falha",
    mainCreateFailAll: "Não foi possível criar a tarifa em nenhum quarto",
    mainUpdated: "Tarifa atualizada",
    updatedPartial: "{ok} atualizadas, {fail} com falha",
    mainUpdateFail: "Não foi possível atualizar a tarifa",
    derivedCreated:
      "Tarifa derivada criada em {count} quarto | Tarifa derivada criada em {count} quartos",
    derivedCreateFail: "Não foi possível criar a tarifa derivada",
    derivedUpdated: "Tarifa derivada atualizada",
    derivedUpdateFail: "Não foi possível atualizar a tarifa derivada",
    roomAddedMain: "Tarifa adicionada a {room}",
    addRateError: "Erro ao adicionar a tarifa",
    noMainRate: "Este quarto não tem a tarifa principal. Adicione-a primeiro.",
    roomAddedDerived: "Tarifa derivada adicionada a {room}",
    addDerivedError: "Erro ao adicionar a tarifa derivada",
    rateRemoved: "Tarifa removida de {room}",
    removeError: "Erro ao remover a tarifa",
    rateDeleted: "Tarifa excluída",
    deletedPartial: "{ok} excluídas, {fail} com falha",
    deleteError: "Erro ao excluir",
  },
  errors: {
    invalidRange: "Selecione um intervalo de datas válido",
    startAfterEnd: "A data de início não pode ser posterior à data de término",
    minStayRange: "Estadia mínima: {minStay} noites, mas o intervalo tem {nights}",
  },
};
